export default function(name, handler, context){
    if (typeof handler === 'function') {
        handler = context ? handler.bind(context) : handler;
  
        this.messageHandlers[name] = this.messageHandlers[name] || [];
        this.messageHandlers[name].push(handler);
    }
}